export default "__VITE_ASSET__B4Duhp$a__"